import React from 'react';
import type { JobItem } from '@/api/types';
import {
  formatJobItemError,
  formatJobItemPayloadSummary,
  jobItemRecipientLabel,
  jobItemSourceName,
} from '@/utils/jobItemErrors';
import { shortId } from '@/utils/jobStatus';

type Props = {
  item: JobItem;
};

function formatTime(value?: string | null): string {
  if (!value) return '—';
  return new Date(value).toLocaleString();
}

export default function JobItemDetailPanel({ item }: Props) {
  const payloadRows = formatJobItemPayloadSummary(item);
  const fullError = formatJobItemError(item.error);

  return (
    <div className="job-item-detail-panel card section">
      <dl className="job-progress-card__meta job-item-detail-panel__grid">
        <div>
          <dt>Full error</dt>
          <dd className="job-item-detail-panel__error">{fullError || '—'}</dd>
        </div>
        <div>
          <dt>Item ID</dt>
          <dd className="mono-id" title={item.id}>
            {item.id}
          </dd>
        </div>
        <div>
          <dt>Source</dt>
          <dd>{jobItemSourceName(item) ?? '—'}</dd>
        </div>
        <div>
          <dt>Recipient</dt>
          <dd>{jobItemRecipientLabel(item) ?? '—'}</dd>
        </div>
        <div>
          <dt>Attempts</dt>
          <dd>
            {item.attempt_count}/{item.max_attempts}
          </dd>
        </div>
        <div>
          <dt>Worker</dt>
          <dd>{item.lease_owner || '—'}</dd>
        </div>
        <div>
          <dt>Started</dt>
          <dd>{formatTime(item.started_at)}</dd>
        </div>
        <div>
          <dt>Finished</dt>
          <dd>{formatTime(item.finished_at)}</dd>
        </div>
        <div>
          <dt>Item key</dt>
          <dd className="mono-id" title={item.item_key || undefined}>
            {item.item_key || '—'}
          </dd>
        </div>
      </dl>
      {payloadRows.length > 0 ? (
        <div className="job-item-detail-panel__payload">
          <h4>Payload</h4>
          <dl className="job-item-detail-panel__payload-grid">
            {payloadRows.map((row) => (
              <div key={row.label}>
                <dt>{row.label}</dt>
                <dd className={row.label.includes('link') || row.label === 'Subscription' ? 'mono-id' : undefined} title={row.value}>
                  {row.label === 'Discovered link' || row.label === 'Subscription'
                    ? shortId(row.value, 12)
                    : row.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}
    </div>
  );
}
